module.exports = __webpack_public_path__ + "img/intercomdescribe6.8f517f8a.png";